module.exports = __webpack_public_path__ + "static/media/gift-list6.cbd47b49.png";